jQuery(document).ready(function(){
    jQuery('.hero_txt_slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        prevArrow: jQuery(".slide_controls .slide-prev"),
    	nextArrow: jQuery(".slide_controls .slide-next")
    });
  jQuery(".testimonial_slide-txt").slick({
  dots: false,
  infinite: false,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
    autoplay:true,
  prevArrow: jQuery(".slide_controls_1 .slide-prev"),
  nextArrow: jQuery(".slide_controls_1 .slide-next"),
});
});
  

